import {contains} from "ramda"
import storage from "hurdak/src/storage"

const NO_SYNC = "sync-instances/noSync"

// Quick mechanism for updating aggressively cached data when it diverges
// across browser tabs: https://ponyfoo.com/articles/cross-tab-communication

let lastSync = 0

export const syncInstancesMiddleware =
  ({actionTypes}) =>
  store => {
    // When an action is registered to be synced, dispatch it
    window.addEventListener("storage", evt => {
      // If the value hasn't changed, the handler won't fire
      // https://stackoverflow.com/a/19150738/1467342
      if (evt.key !== "sync-instances-action" || !evt.newValue) {
        return
      }

      store.dispatch({...JSON.parse(evt.newValue), [NO_SYNC]: true})
    })

    return next => action => {
      next(action)

      const now = new Date().valueOf()

      // If it's one of the actions we're watching, register it in local storage
      // Avoid infinite loop synchronization by adding a delay of a few seconds.
      if (lastSync < now - 10 && contains(action.type, actionTypes) && !action[NO_SYNC]) {
        storage.setJson("sync-instances-action", action)

        lastSync = now
      }
    }
  }
